import * as Console from "effect/Console";
import * as Context from "effect/Context";
import * as Effect from "effect/Effect";
import * as Exit from "effect/Exit";
import * as Layer from "effect/Layer";
import * as Predicate from "effect/Predicate";
export const Sqlite = Context.GenericTag("Sqlite");
export class SqliteFactory extends Context.Tag("SqliteFactory")() {
}
SqliteFactory.Common = Layer.effect(SqliteFactory, Effect.map(SqliteFactory, (platformSqliteFactory) => ({
    createSqlite: Effect.logTrace("SqliteFactory createSqlite").pipe(Effect.zipRight(platformSqliteFactory.createSqlite), Effect.map((platformSqlite) => ({
        ...platformSqlite,
        exec: (query) => platformSqlite.exec(query).pipe(Effect.tap((result) => {
            maybeParseJson(result.rows);
        }), Effect.tap((result) => ["begin", "rollback", "commit"].includes(query.sql)
            ? Effect.logDebug(`SQLiteCommon ${query.sql} transaction`)
            : Effect.logDebug(["SQLiteCommon exec", query, result]))),
        transaction: (mode) => (effect) => {
            // Shared is for readonly queries.
            if (mode === "shared")
                return platformSqlite.transaction(mode)(effect);
            return Effect.flatMap(Sqlite, (sqlite) => Effect.acquireUseRelease(sqlite.exec({ sql: "begin" }), () => effect, (_, exit) => Exit.isFailure(exit)
                ? sqlite.exec({ sql: "rollback" })
                : sqlite.exec({ sql: "commit" }))).pipe(platformSqlite.transaction(mode));
        },
    }))),
})));
export const isJsonObjectOrArray = (value) => value !== null && typeof value === "object" && !Predicate.isUint8Array(value);
export const valuesToSqliteValues = (values) => values.map((value) => isJsonObjectOrArray(value) ? JSON.stringify(value) : value);
/** This function mutates for better performance. */
export const maybeParseJson = (rows) => {
    parseArray(rows);
};
const parseArray = (a) => {
    for (let i = 0; i < a.length; ++i)
        a[i] = parse(a[i]);
    return a;
};
const parse = (o) => {
    if (Predicate.isString(o))
        return parseString(o);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    if (Array.isArray(o))
        return parseArray(o);
    if (typeof o === "object" && o !== null && !Predicate.isUint8Array(o))
        return parseObject(o);
    return o;
};
const parseString = (s) => {
    if (maybeJson(s))
        try {
            return parse(JSON.parse(s));
        }
        catch (err) {
            // Nothing to do.
        }
    return s;
};
export const maybeJson = (value) => value.match(/^[[{]/) != null;
const parseObject = (o) => {
    for (const key in o)
        o[key] = parse(o[key]);
    return o;
};
/** This is good enough detection because SQL strings in Evolu are predictable. */
const isSqlMutationRegEx = new RegExp(`\\b(${[
    "alter",
    "create",
    "delete",
    "drop",
    "insert",
    "replace",
    "update",
].join("|")})\\b`);
export const isSqlMutation = (sql) => isSqlMutationRegEx.test(sql);
export const maybeLogSqliteQueryExecutionTime = (query) => (effect) => {
    if (!query.options?.logQueryExecutionTime)
        return effect;
    return Effect.Do.pipe(Effect.let("start", () => performance.now()), Effect.bind("result", () => effect), Effect.let("elapsed", ({ start }) => performance.now() - start), Effect.tap(({ elapsed }) => Console.log(`QueryExecutionTime: ${elapsed}ms`, query)), Effect.map(({ result }) => result));
};
export const drawSqliteQueryPlan = (rows) => rows
    .map((row) => {
    let parentId = row.parent;
    let indent = 0;
    do {
        const parent = rows.find((r) => r.id === parentId);
        if (!parent)
            break;
        parentId = parent.parent;
        indent++;
        // eslint-disable-next-line no-constant-condition
    } while (true);
    return `${"  ".repeat(indent)}${row.detail}`;
})
    .join("\n");
